/**
 * Application Configuration
 * Single source of truth for runtime configuration.
 * Evaluated once at app startup.
 */

function resolveApiUrl(): string {
	// 1. Explicit env var override (highest priority)
	const envUrl = import.meta.env.VITE_API_URL;
	if (envUrl) {
		return envUrl;
	}

	// 2. Development mode: use localhost
	if (import.meta.env.DEV) {
		return 'http://localhost:3000/api';
	}

	// 3. Production: auto-detect from current domain
	// Works for both staging (stg.schule-leichter.de) and production (schule-leichter.de)
	if (typeof window !== 'undefined') {
		return `${window.location.origin}/api`;
	}

	// 4. SSR/Build-time fallback
	throw new Error('Unable to determine API URL. Set VITE_API_URL in .env');
}

export const config = {
	/** Base URL for API requests */
	apiUrl: resolveApiUrl(),

	/** Application name */
	appName: import.meta.env.VITE_APP_NAME || 'Schule Leichter',

	/** Current environment */
	env: import.meta.env.VITE_ENV || (import.meta.env.DEV ? 'development' : 'production'),

	/** Stripe publishable key (only needed if using Stripe) */
	stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',

	/** Is development mode */
	isDev: import.meta.env.DEV,

	/** Is production mode */
	isProd: import.meta.env.PROD,
} as const;

import { debug } from '@/utils/logger';

// Log config on startup (dev only)
if (import.meta.env.DEV) {
	debug('🔧 App Config:', {
		apiUrl: config.apiUrl,
		appName: config.appName,
		env: config.env,
	});
}
